// Waits for a promise that may never settle (a Socket.IO request whose ack was lost with the
// connection), but no longer than `ms`; a rejection still reaches the caller
const waitAtMost = <T>(promise: Promise<T>, ms: number) => new Promise<T | undefined>((resolve, reject) => {
  const timer = setTimeout(() => resolve(undefined), ms);
  promise.then((value) => {
    clearTimeout(timer);
    resolve(value);
  }, (err) => {
    clearTimeout(timer);
    reject(err);
  });
});

export default waitAtMost;
